import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Rodal from 'rodal';

import { fromQueryParams } from '../../../utils';

import './style.scss';

const NewCandidate = (props) => {
  const {
    createCandidate,
    history,
    isLoggedIn,
    location: {
      search,
    },
  } = props;

  const { raceId } = fromQueryParams(search);

  if (!raceId) history.goBack();

  const [candidateName, setCandidateName] = useState('');
  const [candidateParty, setCandidateParty] = useState('');
  const [candidateBio, setCandidateBio] = useState('');
  const [candidateFB, setCandidateFB] = useState('');
  const [candidateTwitter, setCandidateTwitter] = useState('');
  const [candidateInstagram, setCandidateInstagram] = useState('');
  const [candidateEmail, setCandidateEmail] = useState('');
  const [candidatePhoneNumber, setCandidatePhoneNumber] = useState('');
  const [candidateWebsite, setCandidateWebsite] = useState('');

  const [errorText, setErrorText] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);

  useEffect(() => {
    if (!isLoggedIn) {
      setModalVisible(true);
    } else {
      setModalVisible(false);
    }
  }, [isLoggedIn]);

  const valueSetter = setter => (e) => {
    setter(e.target.value);
    setErrorText('');
  };

  const onSubmitPress = () => {
    const fields = {
      name: candidateName,
      party: candidateParty,
      biographical_info: candidateBio,
      social_media: {
        facebook: candidateFB,
        twitter: candidateTwitter,
        instagram: candidateInstagram,
      },
      contact_info: {
        email: candidateEmail,
        phone_number: candidatePhoneNumber,
        website: candidateWebsite,
      },
    };

    if (!candidateName) return setErrorText('Please provide the candidate\'s name');
    if (!candidateParty) return setErrorText('Please provide the candidate\'s party');

    return createCandidate(fields, raceId, () => {
      setSuccessModalVisible(true);
    }, (err) => {
      if (err.response.data === 'Unauthorized') {
        setErrorText('You must be signed in to report a new candidate');
      } else {
        setErrorText(JSON.stringify(err.response.data));
      }
    });
  };

  return (
    <div id="new-candidate-content">
      <h1>Report A New Candidate</h1>
      <div id="content-container">
        <table>
          <tr>
            <th>Candidate Name</th>
            <th>
              <input className="val" value={candidateName} onChange={valueSetter(setCandidateName)} />
            </th>
          </tr>
          <tr>
            <th>Candidate Party</th>
            <th>
              <input className="val" value={candidateParty} onChange={valueSetter(setCandidateParty)} />
            </th>
          </tr>
          <tr>
            <th>Brief Candidate Bio (one-sentence)</th>
            <th>
              <input className="val" value={candidateBio} onChange={valueSetter(setCandidateBio)} />
            </th>
          </tr>
          <tr>
            <th>Candidate Facebook</th>
            <th>
              <input className="val" value={candidateFB} onChange={valueSetter(setCandidateFB)} />
            </th>
          </tr>
          <tr>
            <th>Candidate Twitter</th>
            <th>
              <input className="val" value={candidateTwitter} onChange={valueSetter(setCandidateTwitter)} />
            </th>
          </tr>
          <tr>
            <th>Candidate Instagram</th>
            <th>
              <input className="val" value={candidateInstagram} onChange={valueSetter(setCandidateInstagram)} />
            </th>
          </tr>
          <tr>
            <th>Candidate Email</th>
            <th>
              <input className="val" value={candidateEmail} onChange={valueSetter(setCandidateEmail)} />
            </th>
          </tr>
          <tr>
            <th>Candidate Phone Number</th>
            <th>
              <input className="val" value={candidatePhoneNumber} onChange={valueSetter(setCandidatePhoneNumber)} />
            </th>
          </tr>
          <tr>
            <th>Candidate Website</th>
            <th>
              <input className="val" value={candidateWebsite} onChange={valueSetter(setCandidateWebsite)} />
            </th>
          </tr>
        </table>
      </div>
      <div id="submit-container">
        {errorText && <p>{errorText}</p>}
        <button type="button" onClick={onSubmitPress}>
          Submit
        </button>
      </div>
      <Rodal visible={successModalVisible} onClose={() => setSuccessModalVisible(false)}>
        <div id="modal-success-content">
          <h2>Success!</h2>
          <p>We&apos;ve successfully added this candidate to our system.</p>
          <p>It will appear on the website once our moderators review it.</p>
          <button type="button" onClick={() => history.push(`/race/${raceId}`)}>
            Back To Candidates
          </button>
        </div>
      </Rodal>
      <Rodal visible={modalVisible} onClose={() => setModalVisible(false)}>
        <div id="modal-no-auth-content">
          <h2>Uh oh!</h2>
          <p>Looks like you&apos;re not logged in.</p>
          <p>You must have an account to report new candidates.</p>
          <h4 id="auth-prompt">Please <Link to="/sign-up">sign up</Link> or <Link to="/login">login</Link> to report a new candidate.</h4>
        </div>
      </Rodal>
    </div>
  );
};

export default NewCandidate;
